// extracted by mini-css-extract-plugin
module.exports = {"main":"list_main__ZMB8Z"};